<template>
  <div class="linkOrderDetail column-me">
    <div class="row-me row-center">
      <div class="blue-line"></div>
      <div class="black-title">基本信息</div>
    </div>
    <div class="table-border-l-t margin-top20">
      <div class="row-me">
        <div class="title">联单号</div>
        <div class="content">{{ detailItem.jointNo }}</div>
        <div class="title">医院名称</div>
        <div class="content">{{ detailItem.hospitalName }}</div>
        <div class="title">机构名称</div>
        <div class="content">{{ detailItem.mechName }}</div>
      </div>
      <div class="row-me">
        <div class="title">处方数</div>
        <div class="content">{{ detailItem.prescriptionNums }}</div>
        <div class="title">联单状态</div>
        <div class="content">
          {{
            this.linkOrderStatusArray.filter(item => {
              return item.id === this.detailItem.orderStatus
            }).map(item => {
              return item.name
            }).join('')
          }}
        </div>
        <div class="title">打印状态</div>
        <div class="content">
          {{
            this.printStatusArray.filter(item => {
              return item.id === this.detailItem.printStatus
            }).map(item => {
              return item.name
            }).join('')
          }}
        </div>
      </div>
      <div class="row-me">
        <div class="title">配送方式</div>
        <div class="content">{{ detailItem.deliveryCompany }}</div>
        <div class="title">快递单号</div>
        <div class="content">{{ detailItem.deliveryNo }}</div>
        <div class="title">寄件类型</div>
        <div class="content">{{ detailItem.sendType }}</div>
      </div>
      <div class="row-me">
        <div class="title">运费方式</div>
        <div class="content row-me">
          <div>
            {{
              detailItem.deliveryType === 0 ? '寄付' : detailItem.deliveryType === 1 ? '到付' : detailItem.deliveryType
              === 2 ? '月结' : ''
            }}
          </div>
          <div v-if="detailItem.isInsure">(保价)</div>
          <div v-if="detailItem.isInsure===false">(不保价)</div>
        </div>
        <div class="title">运费</div>
        <div class="content">
          <div class="row-me row-center" v-if="!canOperate">
            {{ detailItem.freightFee }}
          </div>
          <div v-else>
            <div class="row-me row-center pointer" v-if="code==='freightFee'">
              <div class="flex1">
                <el-input placeholder="请输入" style="width: 100%;" clearable v-model="detailItem.freightFee"
                          @input="detailItem.freightFee=this.$method.checkInput(detailItem.freightFee,2)"></el-input>
              </div>
              <img src="../../assets/img/ok.png" class="img18 objScaleDown paddingLR5" @click="clickOk('freightFee')">
              <img src="../../assets/img/cancel.png" class="img18 objScaleDown paddingLR5" @click="clickCancel">
            </div>
            <div class="row-me row-center pointer" @click="clickEdit('freightFee')" v-else>
              <div class="flex1">{{ detailItem.freightFee }}</div>
              <img src="../../assets/img/edit_blue.png" class="img18 objScaleDown paddingLR5"
                   v-if="detailItem.orderStatus===1">
            </div>
          </div>
        </div>
        <div class="title">制单人</div>
        <div class="content">{{ detailItem.operator }}</div>
      </div>
      <div class="row-me">
        <div class="title">制单时间</div>
        <div class="content">{{ detailItem.createTime }}</div>
        <div class="title">制单备注</div>
        <div class="content">
          <div class="row-me row-center" v-if="!canOperate">
            {{ detailItem.remark }}
          </div>
          <div v-else>
            <div class="row-me row-center pointer" v-if="code==='remark'">
              <div class="flex1">
                <el-input type="textarea" placeholder="请输入" style="width: 100%;" clearable
                          v-model="detailItem.remark" maxlength="100" autosize></el-input>
              </div>
              <img src="../../assets/img/ok.png" class="img18 objScaleDown paddingLR5" @click="clickOk('remark')">
              <img src="../../assets/img/cancel.png" class="img18 objScaleDown paddingLR5" @click="clickCancel">
            </div>
            <div class="row-me row-center pointer" @click="clickEdit('remark')" v-else>
              <div class="flex1">{{ detailItem.remark }}</div>
              <img src="../../assets/img/edit_blue.png" class="img18 objScaleDown paddingLR5"
                   v-if="detailItem.orderStatus===1">
            </div>
          </div>
        </div>
        <div class="title">签收时间</div>
        <div class="content">{{ detailItem.signTime }}</div>
      </div>
      <div class="row-me">
        <div class="title">收货人</div>
        <div class="content">
          <div class="row-me row-center" v-if="!canOperate">
            {{ detailItem.receiveName }}
          </div>
          <div v-else>
            <div class="row-me row-center pointer" v-if="code==='receiveName'">
              <div class="flex1">
                <el-input placeholder="请输入" style="width: 100%;" clearable
                          v-model="detailItem.receiveName"></el-input>
              </div>
              <img src="../../assets/img/ok.png" class="img18 objScaleDown paddingLR5" @click="clickOk('receiveName')">
              <img src="../../assets/img/cancel.png" class="img18 objScaleDown paddingLR5" @click="clickCancel">
            </div>
            <div class="row-me row-center pointer" @click="clickEdit('receiveName')" v-else>
              <div class="flex1">{{ detailItem.receiveName }}</div>
              <img src="../../assets/img/edit_blue.png" class="img18 objScaleDown paddingLR5"
                   v-if="detailItem.orderStatus===1">
            </div>
          </div>
        </div>
        <div class="title">收件电话</div>
        <div class="content">
          <div class="row-me row-center" v-if="!canOperate">
            {{ detailItem.receiveMobile }}
          </div>
          <div v-else>
            <div class="row-me row-center pointer" v-if="code==='receiveMobile'">
              <div class="flex1">
                <el-input placeholder="请输入" style="width: 100%;" clearable
                          @input="detailItem.receiveMobile=this.$method.checkInput(detailItem.receiveMobile,0)"
                          v-model="detailItem.receiveMobile"></el-input>
              </div>
              <img src="../../assets/img/ok.png" class="img18 objScaleDown paddingLR5"
                   @click="clickOk('receiveMobile')">
              <img src="../../assets/img/cancel.png" class="img18 objScaleDown paddingLR5" @click="clickCancel">
            </div>
            <div class="row-me row-center pointer" @click="clickEdit('receiveMobile')" v-else>
              <div class="flex1">{{ detailItem.receiveMobile }}</div>
              <img src="../../assets/img/edit_blue.png" class="img18 objScaleDown paddingLR5"
                   v-if="detailItem.orderStatus===1">
            </div>
          </div>
        </div>
        <div class="title">收货人地址</div>
        <div class="content">
          <div class="row-me row-center" v-if="!canOperate">
            {{ detailItem.receiveProvince || '' }}
            {{ detailItem.receiveCity || '' }}
            {{ detailItem.receiveRegion || '' }}
            {{ detailItem.receiveAddress || '' }}
          </div>
          <div v-else>
            <div class="row-me row-center pointer" @click="clickEditAddress">
              <div class="flex1">
                {{ detailItem.receiveProvince || '' }}
                {{ detailItem.receiveCity || '' }}
                {{ detailItem.receiveRegion || '' }}
                {{ detailItem.receiveAddress || '' }}
              </div>
              <img src="../../assets/img/edit_blue.png" class="img18 objScaleDown paddingLR5"
                   v-if="detailItem.orderStatus===1">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row-me row-center margin-top20">
      <div class="blue-line"></div>
      <div class="black-title">处方单列表</div>
    </div>
    <div class="margin-top20">
      <el-table :data="detailItem.list" border header-cell-class-name="table-header-style"
                cell-class-name="table-cell-style">
        <el-table-column type="index" label="序号" width="80" align="center"/>
        <el-table-column prop="orderNo" label="处方订单号" align="center" show-overflow-tooltip
                         width="230"></el-table-column>
        <el-table-column prop="prescriptionNumber" label="医院单号" align="center"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="patientName" label="患者姓名" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="patientSex" label="性别" align="center" show-overflow-tooltip
                         width="80"></el-table-column>
        <el-table-column prop="patientAge" label="年龄" align="center" show-overflow-tooltip
                         width="80"></el-table-column>
        <el-table-column prop="mechName" label="机构名称" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="processType" label="加工类型" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="doseNums" label="剂数" align="center" show-overflow-tooltip
                         width="100"></el-table-column>
        <el-table-column prop="frequency" label="次数" align="center" show-overflow-tooltip></el-table-column>
      </el-table>
    </div>
    <div class="row-me row-center flex-end1 margin-top30" v-if="canOperate">
      <!--订单状态 0已作废，1已制单，2已签收，3已取消发货，4已发货-->
      <div class="btn-blue width120 btn-height40" @click="clickSend" v-if="detailItem.orderStatus===1">
        发货
      </div>
      <div class="btn-blue width120 btn-height40" @click="clickCancelSend" v-if="detailItem.orderStatus===4">
        取消发货
      </div>
    </div>


    <!-- 收货人地址编辑 -->
    <el-dialog title="收货人地址" v-model="visibleAddress" width="820px" top="20vh" :destroy-on-close="true"
               @close="getDetail">
      <div class="padding-left50 padding-right50">
        <div class="row-me">
          <div class="left-div">收货地址：</div>
          <div class="column-me flex1 margin-left10">
            <div class="row-me row-center">
              <div class="flex1">
                <el-select v-model="detailItem.receiveProvince" placeholder="请选择省" style="width: 100%;" filterable
                           clearable @change="provinceChange">
                  <el-option v-for="item in provinceArray" :key="item.id" :label="item.n"
                             :value="item.n">
                  </el-option>
                </el-select>
              </div>
              <div class="flex1 margin-left10">
                <el-select v-model="detailItem.receiveCity" placeholder="请选择市" style="width: 100%;" filterable
                           clearable @change="cityChange">
                  <el-option v-for="item in cityArray" :key="item.id" :label="item.n" :value="item.n">
                  </el-option>
                </el-select>
              </div>
              <div class="flex1 margin-left10">
                <el-select v-model="detailItem.receiveRegion" placeholder="请选择区/县" style="width: 100%;" filterable
                           clearable>
                  <el-option v-for="item in areaArray" :key="item.id" :label="item.n" :value="item.n">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="flex1 margin-top20">
              <el-input placeholder="请输入详细地址" style="width: 100%;" clearable
                        v-model="detailItem.receiveAddress" maxlength="50"></el-input>
            </div>
          </div>
        </div>

        <div class="row-me row-center flex-end1 margin-top40">
          <div class="btn-blank width100 btn-height40" @click="clickCancelAddress">取消</div>
          <div class="btn-blue width100 btn-height40 margin-left10" @click="clickSaveAddress">确定</div>
        </div>
      </div>
    </el-dialog>

    <!-- 发货弹窗 -->
    <el-dialog title="发货" v-model="visibleSend" width="60%" top="5vh" :destroy-on-close="true">
      <send-dialog :orderArray="[this.$method.deepClone(detailItem)]" source="link"
                   @sendSuccess="sendSuccess"></send-dialog>
    </el-dialog>

  </div>
</template>

<script>

import cityData from "../../assets/js/citys";
import sendDialog from "./sendDialog.vue";

export default {
  components: {
    sendDialog
  },
  props: {
    id: {
      type: Number,
      default: -1,
    }
  },
  data() {
    return {
      detailItem: {},
      code: '',
      visibleAddress: false,
      provinceArray: [],
      cityArray: [],
      areaArray: [],
      linkOrderStatusArray: [
        {id: 0, name: '已作废'},
        {id: 1, name: '已制单'},
        {id: 2, name: '已签收'},
        {id: 3, name: '已取消发货'},
        {id: 4, name: '已发货'}
      ],
      printStatusArray: [
        {id: 1, name: '待打印'},
        {id: 2, name: '已打印'},
      ],
      visibleSend: false,
      canOperate: false,
    }
  },
  // 侦听器
  watch: {},
  // 计算属性
  computed: {},
  // html加载完成之前
  created() {
    this.provinceArray = cityData
    this.$getMenuOperateAuth(this.$route.path).then(res => {
      this.canOperate = res.data
    })
  },
  // html加载完成后执行。
  mounted() {
    this.getDetail()
  },
  // 事件方法执行
  methods: {
    clickEdit(code) {
      if (this.detailItem.orderStatus === 1) {
        this.code = code
      }
    },
    //修改联单保存
    clickOk(code) {
      if (code === 'freightFee' && this.$method.isEmpty(this.detailItem.freightFee)) {
        this.$message.error("运费不能为空")
        return
      }
      if (code === 'receiveName' && this.$method.isEmpty(this.detailItem.receiveName)) {
        this.$message.error("收货人不能为空")
        return
      }
      if (code === 'receiveMobile' && this.$method.isEmpty(this.detailItem.receiveMobile)) {
        this.$message.error("收件电话不能为空")
        return
      }
      let param = this.$method.deepClone(this.detailItem)
      delete param.list
      this.$postRequest('/admin/order/updateJointShipment', param).then((res) => {
        if (res) {
          this.code = ''
          this.$message.success(res.message)
          this.getDetail()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    clickCancel() {
      this.code = ''
      this.getDetail()
    },
    clickEditAddress() {
      if (this.detailItem.orderStatus === 1) {
        this.visibleAddress = true
      }
    },
    provinceChange(e) {
      this.detailItem.receiveCity = ''
      this.detailItem.receiveRegion = ''
      this.cityArray = []
      this.areaArray = []
      if (e && e !== '') {
        for (let i = 0; i < this.provinceArray.length; i++) {
          let item = this.provinceArray[i]
          if (e === item.n) {
            this.cityArray = item.c
          }
        }
      }
    },
    cityChange(e) {
      this.detailItem.receiveRegion = ''
      this.areaArray = []
      if (e && e !== '') {
        for (let i = 0; i < this.cityArray.length; i++) {
          let item = this.cityArray[i]
          if (e === item.n) {
            this.areaArray = item.c
          }
        }
      }
    },
    //地址取消
    clickCancelAddress() {
      this.visibleAddress = false
    },
    //地址编辑确认
    clickSaveAddress() {
      if (this.$method.isEmpty(this.detailItem.receiveProvince) || this.$method.isEmpty(this.detailItem.receiveCity)
          || this.$method.isEmpty(this.detailItem.receiveRegion) || this.$method.isEmpty(this.detailItem.receiveAddress)) {
        this.$message.error('收货地址请填写完整')
        return
      }
      this.visibleAddress = false
      this.clickOk()
    },
    //发货
    clickSend() {
      this.visibleSend = true
    },
    //发货成功
    sendSuccess() {
      this.visibleSend = false
      this.getDetail()
    },
    //取消发货
    clickCancelSend() {
      this.$confirm("您确定要取消发货吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postRequest('/admin/order/fahuoCancel', {
          ids: [this.id],
          type: 2,//1普通订单，2联单
        }).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.getDetail()
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //获取数据
    getDetail() {
      this.$getRequest('/admin/order/getJointShipment', {
        id: this.id,
      }).then((res) => {
        if (res) {
          this.detailItem = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.linkOrderDetail {
  height: 100%;

  .table-border-l-t {
    border-left: 1px solid #E5E9ED;
    border-top: 1px solid #E5E9ED;

    .title {
      width: 100px;
      padding: 8px 10px;
      background: #FAFAFA;
      font-size: 16px;
      color: #7B8CA0;
      border-right: 1px solid #E5E9ED;
      border-bottom: 1px solid #E5E9ED;
    }

    .content {
      flex: 1;
      padding: 8px 10px;
      font-size: 16px;
      color: #252630;
      border-right: 1px solid #E5E9ED;
      border-bottom: 1px solid #E5E9ED;
    }
  }
}
</style>
